import {MembersService} from '../../libs/ui/src/index';

import {client} from '../apiService';

const _MembersService = new MembersService({client});
export {_MembersService as MembersService};
